import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  tableHeader: {
    position: "sticky",
    top: 0,
    borderBottom: "1px solid #eee",
    zIndex: 3
  },
  tableHeaderContainer: {
    display: "flex",
    width: "100%",
    backgroundColor: "#fff",
    padding: "4px 16px 4px 16px",
    height: 44,
    overflow: "hidden"
  },
  tableHeaderContent: {
    display: "grid",
    backgroundColor: "#fff",
    gap: 6
  },
  tableHeaderShadow: {
    position: "sticky",
    top: 40,
    marginTop: -4,
    height: "4px",
    zIndex: 2,
    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.15)"
  },
  headerCell: {
    height: "auto"
  },
  tableColumnDivider: {
    margin: "4px 8px"
  }
});
